import { IParamsBuyInStockList } from 'interfaces/api';

import {
  MARKET_QUERY_BUYIN_STOCK_LIST,
  MARKET_QUERY_BUYIN_STOCK_LIST_FAILED,
  MARKET_QUERY_BUYIN_STOCK_LIST_SUCCESS,
} from 'redux/actions';

export const getBuyInStockList = (data: IParamsBuyInStockList) => {
  return ({
    type: MARKET_QUERY_BUYIN_STOCK_LIST,
    response: {
      success: MARKET_QUERY_BUYIN_STOCK_LIST_SUCCESS,
      failed: MARKET_QUERY_BUYIN_STOCK_LIST_FAILED,
    },
    data,
  });
}


// WEBPACK FOOTER //
// ./src/redux/global-actions/BuyInStockList.ts